import { render, staticRenderFns } from "./TicketLists.vue?vue&type=template&id=1a497450&scoped=true&"
import script from "./TicketLists.vue?vue&type=script&lang=js&"
export * from "./TicketLists.vue?vue&type=script&lang=js&"
import style0 from "./TicketLists.vue?vue&type=style&index=0&id=1a497450&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a497450",
  null
  
)

export default component.exports